import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Config } from "../models/config";
import syncRequest from "sync-request";

let PARSED_CACHED_CONFIG: Config;
let PARSED_CACHED_MAIN_CONFIG: object;

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private mainConfig;
  private http = inject(HttpClient);

  constructor() {
    if (typeof PARSED_CACHED_MAIN_CONFIG === "undefined") {
      const parsedConfig = JSON.parse(
        syncRequest("GET", "assets/vars.json").getBody() as string,
      );
      this.mainConfig = parsedConfig;
      PARSED_CACHED_MAIN_CONFIG = parsedConfig;
    } else {
      this.mainConfig = PARSED_CACHED_MAIN_CONFIG;
    }
  }

  getStyleUrl() {
    if (this.mainConfig.styleUrl) {
      return this.mainConfig.styleUrl;
    }

    const ttNumber = this.mainConfig.ttNumber;

    if ((ttNumber.match(/-/g) || []).length === 2) {
      return (
        "https://" +
        ttNumber.split("-")[0] +
        "apiweb.ticketteam.com/style" +
        ttNumber.split("-")[2] +
        ".css"
      );
    }

    if (ttNumber.includes("-")) {
      return (
        "https://" + ttNumber.split("-")[0] + "apiweb.ticketteam.com/style.css"
      );
    }
    return "https://" + ttNumber + "apiweb.ticketteam.com/style.css";
  }

  getApiUrl(): string {
    return this.getConfig().apiUrl;
  }

  getConfig(): Config {
    if (typeof PARSED_CACHED_CONFIG !== "undefined") {
      return PARSED_CACHED_CONFIG;
    }

    let ttNumberPart = this.mainConfig.ttNumber;

    if (ttNumberPart.includes("-")) {
      ttNumberPart = ttNumberPart.split("-")[0];
    }

    let res = null;

    if (!this.mainConfig.configFile) {
      res = syncRequest("GET", this.mainConfig.configUrl);
    } else {
      res = syncRequest(
        "GET",
        "https://" +
          ttNumberPart +
          "apiweb.sites.ticketteam.cloud/" +
          this.mainConfig.configFile,
      );
    }

    const config = JSON.parse(res.getBody());

    PARSED_CACHED_CONFIG = config;

    return config as Config;
  }

  getTTNumber() {
    return this.mainConfig.ttNumber;
  }
  getTTNumberReversed() {
    const ttNumber: string = this.mainConfig.ttNumber;
    const parts = ttNumber.split("-").reverse();

    const reversedNumber = parts.join("-");
    return reversedNumber;
  }

  getVersion() {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require("package.json").version;
  }

  getProperty(propertyName: string, defaultValue: unknown): unknown {
    if (typeof this.getConfig()[propertyName] === "undefined") {
      return defaultValue;
    }
    return this.getConfig()[propertyName];
  }

  getPlaceId() {
    return this.getConfig().groupId;
  }

  getEnvironmentId() {
    return this.mainConfig.environmentId;
  }
}
